import { render, staticRenderFns } from "./estudo.vue?vue&type=template&id=8d4a5fae"
import script from "./estudo.vue?vue&type=script&lang=js"
export * from "./estudo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports